import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { alphalendWebSocketService } from '../services/alphalendWebsocket';
const AlphalendWebSocketContext = createContext(undefined);
export const useAlphalendWebSocket = () => {
    const context = useContext(AlphalendWebSocketContext);
    if (context === undefined) {
        throw new Error('useAlphalendWebSocket must be used within an AlphalendWebSocketProvider');
    }
    return context;
};
export const AlphalendWebSocketProvider = ({ children, }) => {
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
        if (!isInitialized) {
            alphalendWebSocketService.connect();
            setIsInitialized(true);
        }
    }, [isInitialized]);
    return (_jsx(AlphalendWebSocketContext.Provider, { value: {}, children: children }));
};
